<script>
	import { onMount } from "svelte";
	import { Col, Row } from "sveltestrap";
	import CarDetailsCard from "../../../components/DetailsCard/CarDetailsCard.svelte";
	import Tabs from "../../../components/Tabs/Tabs.svelte";
	import client from "../../../services/client";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { loading, carDetail, evMasterData } from "../../../store/store";
	import About from "./About.svelte";
	import CarIssues from "./CarIssues/CarIssues.svelte";
	// import CarAvailability from "./CarAvailability/CarAvailability.svelte";
	import Booking from "./CarBookings/MainBooking.svelte";
	import { getEvMasterData } from "../../../services/profile.ts";
	export let vehicleId;
	let items = [
		{
			label: "About",
			value: 1,
			component: About,
		},
		{
			label: "Car Issues",
			value: 5,
			component: CarIssues,
		},
		// {
		// 	label: "Car Availability",
		// 	value: 3,
		// 	component: CarAvailability,
		// },
		{
			label: "Bookings",
			value: 4,
			component: Booking,
		},
	];

	let detailData;
	onMount(async () => {
		try {
			loading.set(true);
			const response = await client(`/v1/${vehicleId}/details`, {
				method: "GET",
				version: "Vehicle",
			});

			const resEvMasterData = await getEvMasterData();
			detailData = response.data;
			carDetail.set(response.data);
			evMasterData.set(resEvMasterData.data.data);
			loading.set(false);
		} catch (error) {
			loading.set(false);
			console.log(error);
			console.error(error.response);
		}
	});
</script>

{#if !detailData}
	<LoaderContainer />
{:else}
	<LoaderContainer>
		<Row>
			<Col xs={4}>
				<h5>Car Details</h5>
				<CarDetailsCard {detailData} />
			</Col>
			<Col xs={8}>
				<Tabs {items} {detailData} {vehicleId} />
			</Col>
		</Row>
	</LoaderContainer>
{/if}
